import styled from 'styled-components';
import { motion } from 'framer-motion';

export const SwitchContainer = styled.div<{ $isError?: boolean }>`
  position: relative;
  display: flex;
  background-color: #f5f5f5;
  padding: 7px 3px;
  border-radius: 9999px;
  width: min-content;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ $isError }) => ($isError ? '#e42f1e' : '#f5f5f5')};
  height: fit-content;

  &:focus-visible {
    outline: 4px solid #aaebc2;
  }
`;

export const LabelWrapper = styled.div`
  position: relative;
`;

export const RadioInput = styled.input`
  display: none;
`;

export const Label = styled.label<{ $active?: boolean; $disabled?: boolean }>`
  position: relative;
  padding: 8px 16px;
  border-radius: 9999px;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  color: ${({ $active, $disabled }) => ($active ? '#ffffff' : $disabled ? '#9d9a99' : '#0a0200')};
  background-color: transparent;
  transition: color 0.3s ease;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  white-space: nowrap;

  &:hover {
    color: ${({ $active }) => !$active && '#9d9a99'};
  }
`;

export const Slider = styled(motion.div)<{
  $disabled?: boolean;
}>`
  position: absolute;
  left: 0;
  right: 0;
  top: -3px;
  bottom: -3px;
  background-color: ${({ $disabled }) => ($disabled ? '#9d9a99' : '#217442')};
  border-radius: 9999px;
  z-index: 0;
`;
